// @flow

import React from 'react';
import { makeStyles } from '@material-ui/styles';
import WebformLogo from './WebformLogo';
import ErrorPage from '../Error/ErrorPage';
import getReferrerUrl from '../utils/getReferrerUrl';
import logError from '../utils/logError';

const REF_ERROR = 'ref-error';

const useStyles = makeStyles(() => ({
  root: {
    textAlign: 'center'
  }
}));

type Props = {
  displayName: ?string,
  error: Error,
  hideHeader: boolean,
  hideFooter: boolean,
  params: URLSearchParams,
  src?: string
};

export const WebformError = ({
  error,
  hideHeader,
  hideFooter,
  src,
  displayName,
  params
}: Props) => {
  logError(error);

  const classes = useStyles();
  const referrer = params && params.get(REF_ERROR);

  if (referrer) {
    const url = getReferrerUrl({ key: REF_ERROR, referrer });

    // Disable xss lint because URL interface will encode by default.
    // See `getReferrerUrl` utility function.
    // https://developer.mozilla.org/en-US/docs/Web/API/URL
    if (url) {
      window.location.href = url; // eslint-disable-line xss/no-location-href-assign
    }

    return null;
  } else {
    return (
      <div className={classes.root}>
        {!hideHeader && <WebformLogo src={src} alt={displayName} />}
        <ErrorPage hideFooter={hideFooter} />
      </div>
    );
  }
};
WebformError.displayName = 'WebformError';

export default WebformError;
